import { useTranslate } from '@i18n';
import { Box, Text, u } from '@ui';

import * as css from './styles.css';
import { useParameterRegistration } from './useParameterRegistration';

type ParameterRegistrationProps = {
    id: number;
    values: number[];
    labelType: (typeof LABEL_TYPE)[keyof typeof LABEL_TYPE];
};

export const LABEL_TYPE = {
    PARAMETER: 'PARAMETER',
    POSITION: 'POSITION',
} as const;

export const ParameterRegistration = ({ id, values, labelType }: ParameterRegistrationProps) => {
    const paramRegistration = useParameterRegistration(id, values);
    const t = useTranslate();
    if (!paramRegistration) {
        return null;
    }
    const { displayValue, isWithinCorridors, corridors, uiNode, hitRate, totalCount } = paramRegistration;

    return (
        <Box display="flex" flexDirection="column" gap={u(0.5)}>
            <Box
                display="flex"
                flexDirection={labelType === LABEL_TYPE.PARAMETER ? 'column' : 'row'}
                justifyContent="space-between"
            >
                <Box alignSelf="flex-start">
                    <Text className={css.registrationValue}>
                        {labelType === LABEL_TYPE.PARAMETER && t(uiNode.i18n ?? '-')}
                        {labelType === LABEL_TYPE.POSITION && uiNode.parameter.position?.toUpperCase()}
                    </Text>
                </Box>
                <Box alignSelf="flex-end">
                    <Text color={isWithinCorridors ? 'success' : 'danger'} className={css.registrationValue}>
                        {`${displayValue}${corridors.displaySymbol}`}
                    </Text>
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Text color="inverseMuted" variant="h3">
                    {t('live_analysis.hit_rate')}
                </Text>
                <Text color="inverseMuted" className={css.registrationText}>
                    {hitRate}/{totalCount}
                </Text>
            </Box>
        </Box>
    );
};
